interface GradientBorderProps {
  rounded?: "full" | "4xl";
}

export default function GradientBorder({
  rounded = "4xl",
}: GradientBorderProps) {
  const roundedClass = rounded === "full" ? "rounded-full" : "rounded-4xl";

  return (
    <div
      className={`pointer-events-none absolute inset-0 ${roundedClass} bg-linear-to-r from-[#C8C8C8] to-[#2D2D2D] p-px`}
      style={{
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
      }}
    />
  );
}
